import { DragHandleRule } from '@tiptap/extension-drag-handle';

/**
 * Table structural nodes (tableRow, tableCell, tableHeader) are excluded from
 * the block-level drag handle. These are managed by the table's own row/column
 * handle system (TableHandle). Content inside cells (paragraphs, etc.) remains
 * draggable.
 */
const excludeTableStructuralNodes: DragHandleRule = {
  id: 'excludeTableStructuralNodes',
  evaluate: ({ node }) => {
    const excluded = ['tableRow', 'tableCell', 'tableHeader'];
    return excluded.includes(node.type.name) ? 1000 : 0;
  },
};

export const TABLE_DRAG_RULES: DragHandleRule[] = [excludeTableStructuralNodes];
